import * as ReportNavigationActions from '../actions/report-navigation.actions';

export interface State {
  selectedTab: number;
  selectedReport: {code: string, id?: number};
}

export const initialState: State = {
  selectedTab: 0,
  selectedReport: null
};


export function reducer(
  state = initialState,
  action: ReportNavigationActions.ReportNavigationActionsUnion
): State {
  switch (action.type) {
    case ReportNavigationActions.selectTab.type:
      return {
        ...state,
        selectedTab: action.tab
      };
    case ReportNavigationActions.selectReport.type:
      return {
        ...state,
        selectedReport: action.report
      };
    default: {
      return state;
    }
  }
}

export const getSelectedTab = (state: State) => state.selectedTab;
export const getSelectedReport = (state: State) => state.selectedReport;
